/**
 * Custom form – submit via hook URL as JSON.
 * Finds [data-custom-form] with [data-submit-hook], prevents default submit,
 * validates, builds JSON payload, POSTs, shows success or errors.
 */
(function () {
  const FORM_SELECTOR = '[data-custom-form]';
  const SUBMIT_HOOK_ATTR = 'data-submit-hook';
  const MESSAGE_SELECTOR = '[data-custom-form-message]';
  const SUBMIT_BTN_SELECTOR = '[data-custom-form-submit]';
  const INPUT_SELECTOR = '[data-custom-form-input], [data-custom-form-checkbox]';
  const DEBUG_PARAM = 'form_debug';

  function getSubmitHook(container) {
    const url = container.getAttribute(SUBMIT_HOOK_ATTR);
    return url && url.trim() ? url.trim() : null;
  }

  /** If page URL has dev=1, append backend=dev to the submit URL so production app forwards to dev backend. */
  function getSubmitHookUrl(container) {
    const base = getSubmitHook(container);
    if (!base) return null;
    try {
      const devParam = typeof URLSearchParams !== 'undefined' && new URLSearchParams(window.location.search).get('dev') === '1';
      if (!devParam) return base;
      const hasQuery = base.indexOf('?') !== -1;
      return base + (hasQuery ? '&' : '?') + 'backend=dev';
    } catch (e) {
      return base;
    }
  }

  function isWholesaleApplicationForm(container) {
    const h = getSubmitHook(container);
    return !!(h && h.indexOf('wholesale-application') !== -1);
  }

  var COUNTRY_NAME_TO_CODE = {
    'AFGHANISTAN':'AF','ALBANIA':'AL','ALGERIA':'DZ','ANDORRA':'AD','ANGOLA':'AO',
    'ARGENTINA':'AR','ARMENIA':'AM','AUSTRALIA':'AU','AUSTRIA':'AT','AZERBAIJAN':'AZ',
    'BAHRAIN':'BH','BANGLADESH':'BD','BELARUS':'BY','BELGIUM':'BE','BOLIVIA':'BO',
    'BOSNIA AND HERZEGOVINA':'BA','BRAZIL':'BR','BRUNEI':'BN','BULGARIA':'BG',
    'CAMBODIA':'KH','CAMEROON':'CM','CANADA':'CA','CHILE':'CL','CHINA':'CN',
    'COLOMBIA':'CO','COSTA RICA':'CR','CROATIA':'HR','CUBA':'CU','CYPRUS':'CY',
    'CZECHIA':'CZ','CZECH REPUBLIC':'CZ','DENMARK':'DK','ECUADOR':'EC','EGYPT':'EG',
    'EL SALVADOR':'SV','ESTONIA':'EE','ETHIOPIA':'ET','FIJI':'FJ','FINLAND':'FI',
    'FRANCE':'FR','GEORGIA':'GE','GERMANY':'DE','GHANA':'GH','GREECE':'GR',
    'GUATEMALA':'GT','HONDURAS':'HN','HONG KONG':'HK','HUNGARY':'HU','ICELAND':'IS',
    'INDIA':'IN','INDONESIA':'ID','IRAN':'IR','IRAQ':'IQ','IRELAND':'IE','ISRAEL':'IL',
    'ITALY':'IT','JAMAICA':'JM','JAPAN':'JP','JORDAN':'JO','KAZAKHSTAN':'KZ',
    'KENYA':'KE','KUWAIT':'KW','KYRGYZSTAN':'KG','LAOS':'LA','LATVIA':'LV',
    'LEBANON':'LB','LIBYA':'LY','LIECHTENSTEIN':'LI','LITHUANIA':'LT','LUXEMBOURG':'LU',
    'MACAU':'MO','MALAYSIA':'MY','MALDIVES':'MV','MALTA':'MT','MEXICO':'MX',
    'MOLDOVA':'MD','MONGOLIA':'MN','MONTENEGRO':'ME','MOROCCO':'MA','MOZAMBIQUE':'MZ',
    'MYANMAR':'MM','NEPAL':'NP','NETHERLANDS':'NL','NEW ZEALAND':'NZ',
    'NICARAGUA':'NI','NIGERIA':'NG','NORTH KOREA':'KP','NORTH MACEDONIA':'MK',
    'NORWAY':'NO','OMAN':'OM','PAKISTAN':'PK','PANAMA':'PA','PAPUA NEW GUINEA':'PG',
    'PARAGUAY':'PY','PERU':'PE','PHILIPPINES':'PH','POLAND':'PL','PORTUGAL':'PT',
    'QATAR':'QA','ROMANIA':'RO','RUSSIA':'RU','RWANDA':'RW','SAUDI ARABIA':'SA',
    'SENEGAL':'SN','SERBIA':'RS','SINGAPORE':'SG','SLOVAKIA':'SK','SLOVENIA':'SI',
    'SOMALIA':'SO','SOUTH AFRICA':'ZA','SOUTH KOREA':'KR','SPAIN':'ES',
    'SRI LANKA':'LK','SUDAN':'SD','SWEDEN':'SE','SWITZERLAND':'CH','TAIWAN':'TW',
    'TAJIKISTAN':'TJ','TANZANIA':'TZ','THAILAND':'TH','TIMOR-LESTE':'TL',
    'TUNISIA':'TN','TURKEY':'TR','TURKMENISTAN':'TM','UGANDA':'UG','UKRAINE':'UA',
    'UNITED ARAB EMIRATES':'AE','UNITED KINGDOM':'GB','UNITED STATES':'US',
    'UNITED STATES OF AMERICA':'US','URUGUAY':'UY','UZBEKISTAN':'UZ',
    'VENEZUELA':'VE','VIETNAM':'VN','YEMEN':'YE','ZAMBIA':'ZM','ZIMBABWE':'ZW'
  };

  /** Mirror of isalbi-periscope `normalizeCountryCodeForWholesale` for label + client hints. */
  function normalizeCountryCodeForWholesaleForm(value) {
    var n = String(value || '').trim().toUpperCase();
    if (n === 'AUS') return 'AU';
    if (n === 'NZL') return 'NZ';
    if (n === 'USA') return 'US';
    if (n === 'GBR') return 'GB';
    if (n === 'UK') return 'GB';
    if (n === 'NZ') return 'NZ';
    if (n === 'US') return 'US';
    var fromName = COUNTRY_NAME_TO_CODE[n];
    if (fromName) return fromName;
    if (n.length === 2) return n;
    return '';
  }

  /**
   * Same field name `abn` for AU (ABN) and NZ (NZBN); update label when country is New Zealand.
   */
  function initAbnNzbnLabel(form) {
    var abn = form.querySelector('[name="abn"]');
    var country = form.querySelector('[name="country"]');
    if (!abn || !country) return;
    var label = abn.id ? form.querySelector('label[for="' + String(abn.id).replace(/"/g, '\\"') + '"]') : null;
    if (!label) return;
    if (!label.getAttribute('data-biz-id-original-label')) {
      var t = (label.textContent || '').trim();
      label.setAttribute('data-biz-id-original-label', t || 'ABN');
    }
    function sync() {
      var orig = label.getAttribute('data-biz-id-original-label') || 'ABN';
      var cc = normalizeCountryCodeForWholesaleForm(country.value);
      label.textContent = cc === 'NZ' ? 'NZBN' : orig;
    }
    sync();
    country.addEventListener('change', sync);
    country.addEventListener('input', sync);
  }

  /** Same origin / dev query as submit hook; path wholesale-application → wholesale-validate. */
  function getWholesaleValidateUrl(container) {
    const base = getSubmitHookUrl(container);
    if (!base) return null;
    return base.replace(/wholesale-application(\?|$)/, 'wholesale-validate$1');
  }

  function getWholesaleOnboardingUrl(container) {
    var base = getSubmitHookUrl(container);
    if (!base) return null;
    return base.replace(/wholesale-application(\?|$)/, 'wholesale-onboarding$1');
  }

  function isWholesaleOnboardingFlowEnabled(container) {
    return container.getAttribute('data-wholesale-onboarding-flow') === '1';
  }

  function getWholesaleBusinessStepIndex(container) {
    var steps = container.querySelectorAll('.custom-form__step');
    var i;
    for (i = 0; i < steps.length; i++) {
      if (steps[i].querySelector('[name="abn"]')) return i + 1;
    }
    return 1;
  }

  function wholesaleOnboardingAppendDev(body) {
    try {
      if (typeof URLSearchParams !== 'undefined' && new URLSearchParams(window.location.search).get('dev') === '1') {
        body.backend = 'dev';
      }
    } catch (e) {}
    return body;
  }

  const WHOLESALE_ADDRESS_FIELD_NAMES = ['streetAddress', 'suburb', 'state', 'postcode', 'country'];

  function setWholesaleFieldHighlight(inputEl, on) {
    if (!inputEl) return;
    inputEl.classList.toggle('wholesale-field-validate--error', !!on);
    if (on) {
      inputEl.setAttribute('aria-invalid', 'true');
    } else {
      inputEl.removeAttribute('aria-invalid');
    }
  }

  function clearWholesaleFieldHighlights(form) {
    var abn = form.querySelector('[name="abn"]');
    if (abn) setWholesaleFieldHighlight(abn, false);
    var tnClear = findFieldByName(form, 'tradingName');
    if (tnClear) setWholesaleFieldHighlight(tnClear, false);
    for (var i = 0; i < WHOLESALE_ADDRESS_FIELD_NAMES.length; i++) {
      var el = findFieldByName(form, WHOLESALE_ADDRESS_FIELD_NAMES[i]);
      if (el) setWholesaleFieldHighlight(el, false);
    }
  }

  function isDebug() {
    try {
      return typeof URLSearchParams !== 'undefined' && new URLSearchParams(window.location.search).get(DEBUG_PARAM) === '1';
    } catch (e) {
      return false;
    }
  }

  function buildPayload(form, container) {
    const payload = {};
    const eventName = (container.getAttribute('data-klaviyo-event-name') || '').trim();
    if (eventName) payload.klaviyo_event_name = eventName;
    const notifyEmail = (container.getAttribute('data-klaviyo-notify-email') || '').trim();
    if (notifyEmail) payload.klaviyo_notify_email = notifyEmail;
    const recaptchaKey = container.getAttribute('data-recaptcha-site-key');
    if (recaptchaKey && typeof window.grecaptcha !== 'undefined' && window.grecaptcha.getResponse) {
      try {
        const token = window.grecaptcha.getResponse();
        if (token) payload.recaptcha_token = token;
      } catch (e) {}
    }

    const seenNames = new Set();
    const elements = form.querySelectorAll('input, select, textarea');
    for (let i = 0; i < elements.length; i++) {
      const el = elements[i];
      const name = el.name && el.name.trim();
      if (!name) continue;
      if (el.type === 'hidden' && !el.hasAttribute('data-custom-form-checkbox-hidden')) {
        payload[name] = el.value != null ? String(el.value).trim() : '';
        seenNames.add(name);
        continue;
      }
      if (seenNames.has(name)) continue;

      if (el.hasAttribute('data-custom-form-checkbox-hidden')) {
        const cb = form.querySelector('[data-custom-form-checkbox][name="' + name.replace(/"/g, '\\"') + '"]');
        let val = cb && cb.checked ? cb.value : el.value;
        if (val === 'true' || val === 'false') val = val === 'true';
        payload[name] = val;
        seenNames.add(name);
        continue;
      }
      if (el.hasAttribute('data-custom-form-checkbox')) {
        const hidden = form.querySelector('[data-custom-form-checkbox-hidden][name="' + name.replace(/"/g, '\\"') + '"]');
        let val = el.checked ? el.value : (hidden ? hidden.value : '');
        if (val === 'true' || val === 'false') val = val === 'true';
        payload[name] = val;
        seenNames.add(name);
        continue;
      }
      if (el.type === 'radio') {
        if (el.checked) payload[name] = el.value;
        continue;
      }
      if (el.hasAttribute('data-custom-form-input') || el.matches('select, textarea')) {
        payload[name] = el.value != null ? String(el.value).trim() : '';
        seenNames.add(name);
      }
    }
    return payload;
  }

  function validateForm(form, scope) {
    const root = scope || form;
    const elements = root.querySelectorAll('[required]');
    const errors = [];
    for (let i = 0; i < elements.length; i++) {
      const el = elements[i];
      if (el.type === 'checkbox' || el.type === 'radio') {
        const name = el.name;
        const group = form.querySelectorAll('[name="' + name.replace(/"/g, '\\"') + '"]');
        let filled = false;
        for (let j = 0; j < group.length; j++) {
          if (group[j].checked) { filled = true; break; }
        }
        if (!filled) {
          errors.push({ name: name, message: 'This field is required' });
          const first = form.querySelector('[name="' + name.replace(/"/g, '\\"') + '"]');
          if (first) {
            const wrapper = first.closest('.custom-form__field');
            if (wrapper && (!scope || scope.contains(wrapper))) {
              const errEl = wrapper.querySelector('[data-custom-form-field-error]');
              if (errEl) { errEl.textContent = 'This field is required'; errEl.classList.remove('hidden'); }
            }
          }
        }
        continue;
      }
      const value = el.value != null ? String(el.value).trim() : '';
      if (!value) {
        errors.push({ name: el.name, message: 'This field is required' });
        const wrapper = el.closest('.custom-form__field');
        if (wrapper && (!scope || scope.contains(wrapper))) {
          const errEl = wrapper && wrapper.querySelector('[data-custom-form-field-error]');
          if (errEl) { errEl.textContent = 'This field is required'; errEl.classList.remove('hidden'); }
        }
      }
      if (el.type === 'email' && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        errors.push({ name: el.name, message: 'Please enter a valid email' });
        const wrapper = el.closest('.custom-form__field');
        if (wrapper && (!scope || scope.contains(wrapper))) {
          const errEl = wrapper && wrapper.querySelector('[data-custom-form-field-error]');
          if (errEl) { errEl.textContent = 'Please enter a valid email'; errEl.classList.remove('hidden'); }
        }
      }
    }

    const telFields = root.querySelectorAll('[data-tel-field]');
    for (let t = 0; t < telFields.length; t++) {
      const telField = telFields[t];
      const numberInput = telField.querySelector('[data-tel-number]');
      const digits = numberInput ? numberInput.value.replace(/[\s\-()+]/g, '') : '';
      const wrapper = telField.closest('.custom-form__field');
      const errEl = wrapper && wrapper.querySelector('[data-custom-form-field-error]');
      if (telField.hasAttribute('data-tel-required') && !digits) {
        errors.push({ name: 'contactNumber', message: 'Contact number is required' });
        if (errEl) { errEl.textContent = 'Contact number is required'; errEl.classList.remove('hidden'); }
      } else if (digits && (digits.length < 8 || digits.length > 10)) {
        errors.push({ name: 'contactNumber', message: 'Please enter 8–10 digits' });
        if (errEl) { errEl.textContent = 'Please enter 8–10 digits'; errEl.classList.remove('hidden'); }
      }
    }

    return errors;
  }

  function clearFieldErrors(form) {
    form.querySelectorAll('[data-custom-form-field-error]').forEach(function (el) {
      el.textContent = '';
      el.classList.add('hidden');
    });
    form.querySelectorAll('[aria-invalid="true"]').forEach(function (el) {
      el.removeAttribute('aria-invalid');
    });
  }

  function showMessage(container, message, isError) {
    const msgEl = container.querySelector(MESSAGE_SELECTOR);
    if (!msgEl) return;
    msgEl.textContent = message || '';
    msgEl.classList.remove('hidden', 'bg-success-bg', 'text-success-text', 'bg-error-bg', 'text-error-text');
    if (isError) {
      msgEl.classList.add('bg-error-bg', 'text-error-text');
      setTimeout(function () {
        try {
          msgEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } catch (e) {
          msgEl.scrollIntoView();
        }
      }, 0);
    } else {
      msgEl.classList.add('bg-success-bg', 'text-success-text');
    }
  }

  function hideMessage(container) {
    const msgEl = container.querySelector(MESSAGE_SELECTOR);
    if (msgEl) msgEl.classList.add('hidden');
  }

  function findFieldByName(form, fieldName) {
    if (!fieldName) return null;
    const escaped = String(fieldName).replace(/"/g, '\\"');
    return form.querySelector('[name="' + escaped + '"]');
  }

  function applyBackendErrors(form, container, errors) {
    if (!Array.isArray(errors) || errors.length === 0) return false;

    let firstField = null;
    let firstStepIndex = null;
    const summary = [];

    for (let i = 0; i < errors.length; i++) {
      const err = errors[i] || {};
      const fieldName = typeof err.field === 'string' ? err.field : '';
      const message = typeof err.message === 'string' && err.message.trim()
        ? err.message.trim()
        : 'Invalid value';

      if (fieldName) summary.push(fieldName + ': ' + message);
      else summary.push(message);

      const field = findFieldByName(form, fieldName);
      if (!field) continue;

      if (!firstField) firstField = field;
      field.setAttribute('aria-invalid', 'true');

      const wrapper = field.closest('.custom-form__field');
      const errEl = wrapper && wrapper.querySelector('[data-custom-form-field-error]');
      if (errEl) {
        errEl.textContent = message;
        errEl.classList.remove('hidden');
      }

      const stepEl = field.closest('.custom-form__step');
      if (stepEl && firstStepIndex == null) {
        const idx = parseInt(stepEl.getAttribute('data-step') || '', 10);
        if (!Number.isNaN(idx)) firstStepIndex = idx;
      }
    }

    if (firstStepIndex != null) {
      goToStep(container, firstStepIndex);
    }

    if (firstField && typeof firstField.focus === 'function') {
      try { firstField.focus(); } catch (e) {}
    }

    const defaultError = container.getAttribute('data-error-message') || 'Please check the highlighted fields.';
    showMessage(container, summary.length ? summary.join(' • ') : defaultError, true);
    return true;
  }

  function setSubmitting(container, submitting) {
    const btns = container.querySelectorAll(SUBMIT_BTN_SELECTOR);
    var k;
    for (k = 0; k < btns.length; k++) {
      var btn = btns[k];
      if (!btn) continue;
      const label = container.getAttribute('data-submitting-label') || 'Submitting…';
      if (submitting) {
        btn.disabled = true;
        btn.setAttribute('data-original-text', btn.textContent);
        btn.textContent = label;
      } else {
        btn.disabled = false;
        btn.textContent = btn.getAttribute('data-original-text') || 'Submit';
      }
    }
  }

  function syncConnectRegisterChrome(container, stepIndex) {
    if (container.getAttribute('data-connect-register-layout') !== '1') return;
    var stepper = container.querySelector('[data-connect-stepper]');
    if (stepper) {
      var tabs = stepper.querySelectorAll('[data-connect-step-index]');
      var n = tabs.length;
      var i;
      for (i = 0; i < n; i++) {
        var tab = tabs[i];
        var idx = parseInt(tab.getAttribute('data-connect-step-index') || '0', 10);
        tab.classList.remove(
          'connect-register__step-tab--complete',
          'connect-register__step-tab--current',
          'connect-register__step-tab--upcoming'
        );
        if (idx < stepIndex) tab.classList.add('connect-register__step-tab--complete');
        else if (idx === stepIndex) tab.classList.add('connect-register__step-tab--current');
        else tab.classList.add('connect-register__step-tab--upcoming');
      }
    }
    var loginPrompt = container.querySelector('[data-connect-login-prompt]');
    if (loginPrompt) loginPrompt.hidden = stepIndex !== 1;
  }

  function goToStep(container, stepIndex) {
    const steps = container.querySelectorAll('.custom-form__step');
    const backBtn = container.querySelector('[data-custom-form-back]');
    const nextBtn = container.querySelector('[data-custom-form-next]');
    const submitBtn = container.querySelector('.custom-form__step-submit');
    const backNotice = container.querySelector('[data-back-button-notice]');
    var i;
    for (i = 0; i < steps.length; i++) {
      steps[i].hidden = (i + 1) !== stepIndex;
    }
    if (backBtn) backBtn.hidden = stepIndex <= 1;
    if (nextBtn) nextBtn.hidden = stepIndex >= steps.length;
    if (submitBtn) submitBtn.hidden = stepIndex < steps.length;
    if (backNotice) backNotice.hidden = stepIndex <= 1;
    syncConnectRegisterChrome(container, stepIndex);
    var activeStep = steps[stepIndex - 1];
    if (activeStep) applyColumnFirstTabOrder(activeStep);
  }

  /** First visible .custom-form__step, or 1 if email-gate overlay host is showing (whole step hidden). */
  function getEffectiveCurrentStepIndex(container) {
    var steps = container.querySelectorAll('.custom-form__step');
    var s;
    for (s = 0; s < steps.length; s++) {
      if (!steps[s].hidden) return s + 1;
    }
    var host = container.querySelector('[data-wholesale-onboarding-host]');
    if (host && !host.hidden && host.childElementCount > 0) return 1;
    return 0;
  }

  function initConnectRegisterLoginLinks(container) {
    if (container.getAttribute('data-connect-register-layout') !== '1') return;
    var link = container.querySelector('[data-connect-login-link]');
    if (link) attachWholesaleStoreLoginClick(link, container);
  }

  function showConnectRegisterSuccess(container, form, submittedEmail) {
    var tplWrap = container.querySelector('[data-connect-success-template]');
    var mount = container.querySelector('[data-connect-success-mount]');
    if (!tplWrap || !mount || !tplWrap.firstElementChild) {
      return false;
    }
    var clone = tplWrap.firstElementChild.cloneNode(true);
    var ev = clone.querySelector('[data-connect-success-email-value]');
    if (ev) ev.textContent = submittedEmail || '—';
    mount.innerHTML = '';
    mount.appendChild(clone);
    mount.hidden = false;
    mount.removeAttribute('hidden');
    mount.classList.remove('hidden');
    form.hidden = true;
    var stepper = container.querySelector('[data-connect-stepper]');
    if (stepper) stepper.hidden = true;
    var msgEl = container.querySelector(MESSAGE_SELECTOR);
    if (msgEl) msgEl.classList.add('hidden');
    var actions = container.querySelector('[data-form-actions]');
    if (actions) actions.hidden = true;
    var onboardHost = container.querySelector('[data-wholesale-onboarding-host]');
    if (onboardHost) onboardHost.hidden = true;
    return true;
  }

  function proceedToBusinessStepFromEmailGate(container, form, nextBtn, businessStep) {
    hideMessage(container);
    clearWholesaleOnboardingHost(container);
    if (nextBtn) nextBtn.hidden = false;
    goToStep(container, businessStep);
  }

  function renderWholesaleEmailNotMatchedPanel(container, form, onboardingUrl, nextBtn, businessStep, alreadyRequestedLocation) {
    var host = getWholesaleOnboardingHost(container, form);
    host.className = 'wholesale-email-not-matched connect-register__not-matched';
    var email = container.getAttribute('data-wholesale-gate-email') || '';
    host.innerHTML =
      '<div class="connect-register__info-banner" role="status"><span class="connect-register__info-icon" aria-hidden="true">i</span>' +
      '<p class="connect-register__info-text">The email address <strong data-nm-email></strong> doesn\u2019t match an existing account. This may be because you use a different email for ordering.</p></div>' +
      '<h3 class="connect-register__not-matched-title h4 mt-6 mb-3">Are you an existing IsAlbi customer?</h3>' +
      '<div class="connect-register__not-matched-actions">' +
      '<button type="button" class="btn btn--primary w-full nm-yes">Yes \u2014 look up my account by store name or account number</button>' +
      '<button type="button" class="btn btn--secondary w-full nm-no">No \u2014 I\u2019m a new customer, create my account</button>' +
      '</div>' +
      '<div class="nm-lookup hidden mt-6">' +
      '<h4 class="h5 mt-0 mb-2">Find your existing account</h4>' +
      '<p class="text-sm mb-4 connect-register__not-matched-body">Type to search \u2014 matching accounts appear as you type.</p>' +
      '<div class="grid grid-cols-2 gap-x-theme gap-y-4 mb-3">' +
      '<div class="col-span-2 md:col-span-1"><label class="label">IsAlbi customer account number (optional)</label><input type="text" class="input w-full nm-acct" placeholder="e.g. 10045" autocomplete="off" /></div>' +
      '<div class="col-span-2 md:col-span-1"><label class="label">Store / trading name (optional)</label><input type="text" class="input w-full nm-trade" placeholder="e.g. My Homewares Pty Ltd" autocomplete="off" /></div>' +
      '</div>' +
      '<div class="nm-results hidden mb-3"></div>' +
      '<div class="nm-selected-card hidden mb-3"></div>' +
      '<button type="button" class="btn btn--primary w-full mb-2 nm-confirm hidden">Yes, this is my account \u2014 activate my access</button>' +
      '<button type="button" class="btn btn--secondary w-full nm-skip">I can\u2019t find my account \u2014 register as new</button>' +
      '<div class="nm-lookup-msg hidden mt-3" role="status"></div>' +
      '</div>';

    var emStrong = host.querySelector('[data-nm-email]');
    if (emStrong) emStrong.textContent = email;
    goToStep(container, 1);
    setWholesaleEmailStepFieldsVisible(form, false);
    if (nextBtn) nextBtn.hidden = true;
    var lpNm = container.querySelector('[data-connect-login-prompt]');
    if (lpNm) lpNm.hidden = true;

    var lookupMsg = host.querySelector('.nm-lookup-msg');
    var nmSelectedCompany = null;
    var nmSelectedLocation = null;
    var nmSearchDebounce = null;

    function nmEsc(s) {
      return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    if (alreadyRequestedLocation) {
      host.innerHTML =
        '<div class="connect-register__info-banner" role="status">' +
        '<span class="connect-register__info-icon" aria-hidden="true">i</span>' +
        '<p class="connect-register__info-text" style="margin:0">' +
        'You have already submitted a request to be added to <strong>' + nmEsc(alreadyRequestedLocation) + '</strong>. ' +
        'Our team will be in touch within 24 hours. If you have not heard back, please contact ' +
        '<a href="mailto:onlinesupport@isalbi.com.au">onlinesupport@isalbi.com.au</a>.' +
        '</p></div>';
      host.removeAttribute('hidden');
      return;
    }

    function showNmMsg(el, t, isErr) {
      if (!el) return;
      if (!t) {
        el.innerHTML = '';
        el.classList.add('hidden');
        el.removeAttribute('style');
        return;
      }
      if (isErr) {
        el.textContent = t;
        el.classList.remove('hidden');
        el.style.cssText = 'color:rgb(var(--error-text-color,220 38 38))';
      } else {
        el.innerHTML = '<span aria-hidden="true" style="flex-shrink:0;line-height:1.4">\u2139\ufe0e</span><p style="margin:0">' + nmEsc(t) + '</p>';
        el.classList.remove('hidden');
        el.style.cssText = 'display:flex;gap:0.625rem;align-items:flex-start;padding:0.875rem 1rem;background:#eff6ff;border:1px solid #93c5fd;border-radius:6px;font-size:1.5rem;color:#1e40af;line-height:1.5';
      }
    }

    function renderNmResults(results) {
      var el = host.querySelector('.nm-results');
      if (!el) return;
      if (!results) { el.classList.add('hidden'); el.innerHTML = ''; return; }
      el.classList.remove('hidden');
      if (!results.length) {
        el.innerHTML = '<p style="font-size:1.5rem;color:#6b7280;margin:0.25rem 0">No matching accounts found. Try a different search term.</p>';
        return;
      }
      var html = '<p style="font-size:1.5rem;font-weight:600;color:#374151;margin:0 0 0.5rem">Matching accounts \u2014 click to select yours:</p>';
      html += '<ul style="list-style:none;padding:0;margin:0;border:1px solid #e5e7eb;border-radius:6px;overflow:hidden">';
      results.forEach(function(company, ci) {
        var locs = Array.isArray(company.locations) ? company.locations : [];
        if (locs.length === 0) {
          html += '<li style="padding:0.75rem 1rem;cursor:pointer;border-bottom:1px solid #f3f4f6" data-ci="' + ci + '" data-li="-1">' +
            '<div style="font-weight:600;font-size:1.5rem">' + nmEsc(company.companyName || '') + '</div>' +
            (company.externalId ? '<div style="color:#6b7280;font-size:1.5rem">Account: ' + nmEsc(company.externalId) + '</div>' : '') +
            '</li>';
        } else {
          locs.forEach(function(loc, li) {
            var addrParts = [loc.locationName, loc.address].filter(Boolean);
            html += '<li style="padding:0.75rem 1rem;cursor:pointer;border-bottom:1px solid #f3f4f6" data-ci="' + ci + '" data-li="' + li + '">' +
              '<div style="font-weight:600;font-size:1.5rem">' + nmEsc(company.companyName || '') + '</div>' +
              '<div style="color:#6b7280;font-size:1.5rem">' + nmEsc(addrParts.join(' \u2014 ')) + (company.externalId ? ' (Acct: ' + nmEsc(company.externalId) + ')' : '') + '</div>' +
              '</li>';
          });
        }
      });
      html += '</ul>';
      el.innerHTML = html;
      el._nmData = results;
      var items = el.querySelectorAll('li[data-ci]');
      for (var ix = 0; ix < items.length; ix++) {
        (function(item) {
          item.addEventListener('mouseover', function() { item.style.background = '#f9fafb'; });
          item.addEventListener('mouseout', function() { item.style.background = ''; });
          item.addEventListener('click', function() {
            var ci2 = parseInt(item.getAttribute('data-ci') || '0', 10);
            var li2 = parseInt(item.getAttribute('data-li') || '-1', 10);
            var cmp = (el._nmData || [])[ci2];
            var loc2 = li2 >= 0 && cmp ? (Array.isArray(cmp.locations) ? cmp.locations[li2] : null) : null;
            onSelectNmCompany(cmp, loc2);
          });
        })(items[ix]);
      }
    }

    function onSelectNmCompany(company, loc) {
      nmSelectedCompany = company;
      nmSelectedLocation = loc;
      var resultsEl = host.querySelector('.nm-results');
      if (resultsEl) { resultsEl.classList.add('hidden'); resultsEl.innerHTML = ''; }
      var card = host.querySelector('.nm-selected-card');
      if (card) {
        card.classList.remove('hidden');
        card.style.cssText = 'padding:0.875rem 1rem;background:#f0fdf4;border:1px solid #86efac;border-radius:6px';
        var name = (company && company.companyName) || '';
        var acct = (company && company.externalId) || '';
        var locName = (loc && loc.locationName) || '';
        var addr = (loc && loc.address) || '';
        card.innerHTML =
          '<div style="font-weight:600;font-size:2rem;margin-bottom:0.25rem">' + nmEsc(name) + '</div>' +
          (acct ? '<div style="color:#4b5563;font-size:1.5rem">Account: ' + nmEsc(acct) + '</div>' : '') +
          (locName ? '<div style="color:#4b5563;font-size:1.5rem">Location: ' + nmEsc(locName) + '</div>' : '') +
          (addr ? '<div style="color:#4b5563;font-size:1.5rem">' + nmEsc(addr) + '</div>' : '') +
          '<button type="button" style="background:none;border:none;padding:0;margin-top:0.5rem;color:#2563eb;text-decoration:underline;cursor:pointer;font-size:1.5rem" class="nm-change-sel">Not the right one? Search again</button>';
        var changeBtn = card.querySelector('.nm-change-sel');
        if (changeBtn) {
          changeBtn.addEventListener('click', function() {
            nmSelectedCompany = null; nmSelectedLocation = null;
            card.classList.add('hidden'); card.innerHTML = '';
            var confirmBtn = host.querySelector('.nm-confirm');
            if (confirmBtn) confirmBtn.classList.add('hidden');
            var acctEl = host.querySelector('.nm-acct');
            var trEl = host.querySelector('.nm-trade');
            var acctQ = (acctEl && acctEl.value ? String(acctEl.value).trim() : '');
            var trQ = (trEl && trEl.value ? String(trEl.value).trim() : '');
            if (acctQ.length >= 2) doNmSearch(acctQ, 'accountNumber', false);
            else if (trQ.length >= 2) doNmSearch(trQ, 'name', false);
          });
        }
      }
      var confirmBtn = host.querySelector('.nm-confirm');
      if (confirmBtn) confirmBtn.classList.remove('hidden');
    }

    function doNmSearch(query, searchBy, debounced) {
      if (debounced) {
        if (nmSearchDebounce) clearTimeout(nmSearchDebounce);
        nmSearchDebounce = setTimeout(function() { doNmSearch(query, searchBy, false); }, 350);
        return;
      }
      if (!query || query.length < 2) { renderNmResults(null); return; }
      postWholesaleOnboarding(onboardingUrl, wholesaleOnboardingAppendDev({ action: 'companySearch', query: query, searchBy: searchBy }))
        .then(function(r) {
          if (!r.httpOk || !r.data || r.data.success !== true) { renderNmResults([]); return; }
          renderNmResults(r.data.results || []);
        })
        .catch(function() { renderNmResults([]); });
    }

    function doNmConfirmLookup(acctVal, trVal) {
      var companyNameFallback = (nmSelectedCompany && nmSelectedCompany.companyName) ? nmSelectedCompany.companyName : '';
      var companyAcctFallback = (nmSelectedCompany && nmSelectedCompany.externalId) ? nmSelectedCompany.externalId : '';
      var confirmBtn = host.querySelector('.nm-confirm');
      if (confirmBtn) { confirmBtn.disabled = true; confirmBtn.textContent = 'Checking\u2026'; }
      postWholesaleOnboarding(onboardingUrl, wholesaleOnboardingAppendDev({
        action: 'secondaryLookup',
        email: container.getAttribute('data-wholesale-gate-email') || '',
        accountNumber: companyAcctFallback || acctVal,
        tradingName: companyNameFallback || trVal,
      })).then(function(r) {
        if (confirmBtn) { confirmBtn.disabled = false; confirmBtn.textContent = 'Yes, this is my account \u2014 activate my access'; }
        if (!r.httpOk || !r.data || r.data.success !== true) {
          showNmMsg(lookupMsg, (r.data && r.data.error) || 'Lookup failed.', true);
          return;
        }
        if (r.data.outcome === 'already_requested') {
          var locName = r.data.locationName ? String(r.data.locationName) : 'this company';
          var dupMsg = 'You have already submitted a request to be added to ' + locName + '. Our team will be in touch within 24 hours. If you have not heard back, please contact onlinesupport@isalbi.com.au.';
          if (lookupMsg) {
            lookupMsg.innerHTML =
              '<span class="connect-register__info-icon" aria-hidden="true">i</span>' +
              '<p class="connect-register__info-text" style="margin:0">' + nmEsc(dupMsg) + '</p>';
            lookupMsg.className = 'connect-register__info-banner nm-lookup-msg';
            lookupMsg.removeAttribute('style');
            lookupMsg.classList.remove('hidden');
          }
          var nmSkipBtnDup = host.querySelector('.nm-skip');
          if (confirmBtn) confirmBtn.hidden = true;
          if (nmSkipBtnDup) nmSkipBtnDup.hidden = true;
          return;
        }
        if (r.data.outcome === 'pending_sales_activation') {
          var pendingMsg = "Your request has been submitted. A confirmation email has been sent to you and our team will be in touch within 24 hours.";
          if (r.data.staffNotified === false) {
            pendingMsg += ' If you do not hear back, please contact IsAlbi support.';
          }
          if (lookupMsg) {
            lookupMsg.innerHTML =
              '<span class="connect-register__info-icon" aria-hidden="true">i</span>' +
              '<p class="connect-register__info-text" style="margin:0">' + nmEsc(pendingMsg) + '</p>';
            lookupMsg.className = 'connect-register__info-banner nm-lookup-msg';
            lookupMsg.removeAttribute('style');
            lookupMsg.classList.remove('hidden');
          }
          var nmSkipBtn = host.querySelector('.nm-skip');
          if (confirmBtn) confirmBtn.hidden = true;
          if (nmSkipBtn) nmSkipBtn.hidden = true;
          return;
        }
        showNmMsg(lookupMsg, 'No match found. You can continue with registration as a new customer.', false);
      }).catch(function() {
        if (confirmBtn) { confirmBtn.disabled = false; confirmBtn.textContent = 'Yes, this is my account \u2014 activate my access'; }
        showNmMsg(lookupMsg, 'Lookup failed. Please try again.', true);
      });
    }

    host.querySelector('.nm-no').addEventListener('click', function() {
      proceedToBusinessStepFromEmailGate(container, form, nextBtn, businessStep);
    });
    host.querySelector('.nm-yes').addEventListener('click', function() {
      host.querySelector('.nm-lookup').classList.remove('hidden');
      host.querySelector('.nm-yes').hidden = true;
      host.querySelector('.nm-no').hidden = true;
    });
    host.querySelector('.nm-skip').addEventListener('click', function() {
      proceedToBusinessStepFromEmailGate(container, form, nextBtn, businessStep);
    });
    host.querySelector('.nm-confirm').addEventListener('click', function() {
      var acctEl = host.querySelector('.nm-acct');
      var trEl = host.querySelector('.nm-trade');
      var acctVal = acctEl && acctEl.value ? String(acctEl.value).trim() : '';
      var trVal = trEl && trEl.value ? String(trEl.value).trim() : '';
      doNmConfirmLookup(acctVal, trVal);
    });
    var acctIn = host.querySelector('.nm-acct');
    var tradeIn = host.querySelector('.nm-trade');
    if (acctIn) acctIn.addEventListener('input', function(e) { doNmSearch(String(e.target.value || '').trim(), 'accountNumber', true); });
    if (tradeIn) tradeIn.addEventListener('input', function(e) { doNmSearch(String(e.target.value || '').trim(), 'name', true); });
  }

  function fieldValueByName(form, name) {
    var el = findFieldByName(form, name);
    return el && el.value != null ? String(el.value).trim() : '';
  }

  function setAbnExistingAccountError(form) {
    var el = findFieldByName(form, 'abn');
    if (!el) return;
    var wrap = el.closest('.custom-form__field');
    var errEl = wrap && wrap.querySelector('[data-custom-form-field-error]');
    if (!errEl) return;
    var msg = document.createElement('span');
    msg.textContent = 'An account with this ABN is already registered. ';
    var link = document.createElement('a');
    link.href = '/account/login';
    link.textContent = 'Log in to access your account';
    link.className = 'abn-login-link';
    errEl.textContent = '';
    errEl.appendChild(msg);
    errEl.appendChild(link);
    errEl.classList.remove('hidden');
  }

  function setCustomFormFieldError(form, fieldName, message) {
    var el = findFieldByName(form, fieldName);
    if (!el) return;
    var wrap = el.closest('.custom-form__field');
    var errEl = wrap && wrap.querySelector('[data-custom-form-field-error]');
    if (!errEl) return;
    if (message) {
      errEl.textContent = message;
      errEl.classList.remove('hidden');
    } else {
      errEl.textContent = '';
      errEl.classList.add('hidden');
    }
  }

  function clearWholesaleStep1InlineErrors(form) {
    setCustomFormFieldError(form, 'abn', '');
    setCustomFormFieldError(form, 'tradingName', '');
    for (var c = 0; c < WHOLESALE_ADDRESS_FIELD_NAMES.length; c++) {
      setCustomFormFieldError(form, WHOLESALE_ADDRESS_FIELD_NAMES[c], '');
    }
  }

  function isLegacyWholesaleFieldError(data) {
    if (!data || typeof data !== 'object') return false;
    var e = data.error || data.message;
    if (typeof e !== 'string') return false;
    if (/step1/i.test(e)) return false;
    if (/"abn"\s+or\s+"address"/.test(e)) return true;
    if (/'abn'\s+or\s+'address'/.test(e)) return true;
    if (/abn["'][^]{0,20}or[^]{0,20}address/.test(e) && /field/i.test(e)) return true;
    return false;
  }

  function postWholesaleValidate(validateUrl, body) {
    return fetch(validateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.text().then(function (text) {
        var data = {};
        try {
          data = text ? JSON.parse(text) : {};
        } catch (e3) {
          data = {};
        }
        return { httpOk: res.ok, data: data };
      });
    });
  }

  function postWholesaleOnboarding(onboardingUrl, body) {
    return fetch(onboardingUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.text().then(function (text) {
        var data = {};
        try {
          data = text ? JSON.parse(text) : {};
        } catch (eOtp) {
          data = {};
        }
        return { httpOk: res.ok, status: res.status, data: data };
      });
    });
  }

  function runWholesaleStep1Validation(validateUrl, stepPayload) {
    return postWholesaleValidate(validateUrl, stepPayload).then(function (first) {
      if (first.httpOk) return first;
      if (stepPayload.field === 'step1' && isLegacyWholesaleFieldError(first.data)) {
        var backend = stepPayload.backend;
        var aBody = {
          field: 'abn',
          abn: stepPayload.abn,
          country: stepPayload.country,
          tradingName: stepPayload.tradingName
        };
        if (backend) aBody.backend = backend;
        var bBody = {
          field: 'address',
          streetAddress: stepPayload.streetAddress,
          suburb: stepPayload.suburb,
          state: stepPayload.state,
          postcode: stepPayload.postcode,
          country: stepPayload.country
        };
        if (backend) bBody.backend = backend;
        return Promise.all([postWholesaleValidate(validateUrl, aBody), postWholesaleValidate(validateUrl, bBody)]).then(
          function (pair) {
            var a = pair[0];
            var b = pair[1];
            if (!a.httpOk) return a;
            if (!b.httpOk) return b;
            var av = a.data && a.data.valid === true;
            var bv = b.data && b.data.valid === true;
            return {
              httpOk: true,
              data: {
                valid: av && bv,
                abn: {
                  valid: av,
                  message: a.data && a.data.message,
                  highlightFields: a.data && a.data.highlightFields
                },
                address: {
                  valid: bv,
                  message: b.data && b.data.message,
                  highlightFields: b.data && b.data.highlightFields
                }
              }
            };
          }
        );
      }
      return first;
    });
  }

  function applyWholesaleStep1ResultUI(form, container, d) {
    clearWholesaleStep1InlineErrors(form);
    var parts = [];
    if (d.abn && d.abn.valid === false && d.abn.message) {
      parts.push(d.abn.message);
    }
    if (d.address && d.address.valid === false && d.address.message) {
      parts.push(d.address.message);
    }
    var topMsg = parts.length
      ? 'Please check the following and update the highlighted fields. ' + parts.join(' ')
      : 'Please check the highlighted fields.';

    if (d.abn && d.abn.valid === false) {
      if (d.abn.existingAccount) {
        var abnFieldEx = findFieldByName(form, 'abn');
        if (abnFieldEx) setWholesaleFieldHighlight(abnFieldEx, true);
        setAbnExistingAccountError(form);
      } else {
        var hfAbn = d.abn.highlightFields;
        var abnMsg = d.abn.message || 'Invalid value';
        if (hfAbn && hfAbn.length) {
          var hi;
          for (hi = 0; hi < hfAbn.length; hi++) {
            var feAbn = findFieldByName(form, hfAbn[hi]);
            if (feAbn) setWholesaleFieldHighlight(feAbn, true);
          }
          for (hi = 0; hi < hfAbn.length; hi++) {
            setCustomFormFieldError(form, hfAbn[hi], abnMsg);
          }
        } else {
          var abnField = findFieldByName(form, 'abn');
          if (abnField) {
            setWholesaleFieldHighlight(abnField, true);
            setCustomFormFieldError(form, 'abn', abnMsg);
          }
        }
      }
    }
    if (d.address && d.address.valid === false) {
      var hf = d.address.highlightFields;
      if (!hf || !hf.length) {
        hf = WHOLESALE_ADDRESS_FIELD_NAMES;
      }
      var j;
      for (j = 0; j < hf.length; j++) {
        var fe = findFieldByName(form, hf[j]);
        if (fe) setWholesaleFieldHighlight(fe, true);
      }
      var addrMsg = d.address.message || 'Please check your address.';
      var firstAddr = 'streetAddress';
      for (j = 0; j < hf.length; j++) {
        if (findFieldByName(form, hf[j])) {
          firstAddr = hf[j];
          break;
        }
      }
      for (j = 0; j < WHOLESALE_ADDRESS_FIELD_NAMES.length; j++) {
        var nm = WHOLESALE_ADDRESS_FIELD_NAMES[j];
        setCustomFormFieldError(form, nm, nm === firstAddr ? addrMsg : '');
      }
    }

    showMessage(container, topMsg, true);
    if (d.abn && d.abn.valid === false) {
      var hfFocus = d.abn.highlightFields;
      var focusEl = null;
      if (hfFocus && hfFocus.length) {
        var fi;
        for (fi = 0; fi < hfFocus.length; fi++) {
          focusEl = findFieldByName(form, hfFocus[fi]);
          if (focusEl) break;
        }
      }
      if (!focusEl) focusEl = findFieldByName(form, 'abn');
      if (focusEl && typeof focusEl.focus === 'function') {
        try {
          focusEl.focus();
        } catch (eF) {}
      }
    } else if (d.address && d.address.valid === false) {
      var hf2 = d.address.highlightFields;
      if (!hf2 || !hf2.length) hf2 = WHOLESALE_ADDRESS_FIELD_NAMES;
      for (var f = 0; f < hf2.length; f++) {
        var elz = findFieldByName(form, hf2[f]);
        if (elz && typeof elz.focus === 'function') {
          try {
            elz.focus();
            break;
          } catch (eF2) {}
        }
      }
    }
  }

  function clearWholesaleOnboardingHost(container) {
    var h = container.querySelector('[data-wholesale-onboarding-host]');
    if (h) {
      h.innerHTML = '';
      h.hidden = true;
    }
  }

  function getWholesaleOnboardingHost(container, form) {
    var host = container.querySelector('[data-wholesale-onboarding-host]');
    if (!host) {
      host = document.createElement('div');
      host.setAttribute('data-wholesale-onboarding-host', '');
      host.className = 'col-span-2 mt-4 mb-2';
      var msg = container.querySelector(MESSAGE_SELECTOR);
      if (msg && msg.parentNode) msg.parentNode.insertBefore(host, msg.nextSibling);
      else form.appendChild(host);
    }
    host.hidden = false;
    return host;
  }

  /** Same behaviour as header `.js-header-login-link`: optional logout first when already logged in. */
  function setWholesaleEmailStepFieldsVisible(form, visible) {
    var step1 = form.querySelector('.custom-form__step[data-step="1"]');
    if (!step1) return;
    step1.hidden = !visible;
  }

  function attachWholesaleStoreLoginClick(anchor, container) {
    if (!anchor || !container) return;
    var loginPath = (container.getAttribute('data-wholesale-login-path') || '').trim();
    if (loginPath) anchor.setAttribute('href', loginPath);
    var isLoggedIn = container.getAttribute('data-wholesale-is-logged-in') === 'true';
    var logoutUrl = (container.getAttribute('data-wholesale-logout-url') || '').trim();
    anchor.addEventListener('click', function (e) {
      if (!isLoggedIn) return;
      e.preventDefault();
      function goLogin() {
        window.location.href = loginPath;
      }
      if (!logoutUrl) {
        goLogin();
        return;
      }
      fetch(logoutUrl, { method: 'GET', credentials: 'same-origin' }).then(goLogin).catch(goLogin);
    });
  }

  function renderWholesaleExistingAccountPanel(container, form, nextBtn) {
    var host = getWholesaleOnboardingHost(container, form);
    host.className = 'wholesale-existing-account';
    var email = container.getAttribute('data-wholesale-gate-email') || '';
    var custom = container.getAttribute('data-wholesale-b2b-complete-msg');
    if (custom) {
      host.innerHTML =
        '<h3 class="custom-form__step-title h5 mt-0 mb-4">Account already exists</h3>' +
        '<p class="text-sm mb-4" style="opacity:0.9;white-space:pre-line" data-ex-msg></p>' +
        '<p class="text-sm mb-1" style="opacity:0.85">Registered email</p>' +
        '<p class="text-base font-medium mb-0" data-ex-email></p>' +
        '<div class="wholesale-existing-account__actions">' +
        '<a class="btn btn--primary js-wholesale-header-login" href="#">Log in</a>' +
        '<button type="button" class="btn btn--secondary" data-ex-retry>Use a different email</button>' +
        '</div>';
      var msgEl = host.querySelector('[data-ex-msg]');
      if (msgEl) msgEl.textContent = custom;
    } else {
      host.innerHTML =
        '<h3 class="custom-form__step-title h5 mt-0 mb-4">Account already exists</h3>' +
        '<p class="text-sm mb-4" style="opacity:0.9">We found a customer account in our store that uses this email address.</p>' +
        '<p class="text-sm mb-1" style="opacity:0.85">Registered email</p>' +
        '<p class="text-base font-medium mb-6" data-ex-email></p>' +
        '<p class="text-sm mb-6" style="opacity:0.9">You don\'t need to register again. Click to log in below.</p>' +
        '<div class="wholesale-existing-account__actions">' +
        '<a class="btn btn--primary js-wholesale-header-login" href="#">Log in</a>' +
        '<button type="button" class="btn btn--secondary" data-ex-retry>Use a different email</button>' +
        '</div>';
    }
    var emailEl = host.querySelector('[data-ex-email]');
    if (emailEl) emailEl.textContent = email;
    var loginA = host.querySelector('.js-wholesale-header-login');
    attachWholesaleStoreLoginClick(loginA, container);
    host.querySelector('[data-ex-retry]').addEventListener('click', function () {
      clearWholesaleOnboardingHost(container);
      hideMessage(container);
      goToStep(container, 1);
      if (nextBtn) nextBtn.hidden = false;
    });
    goToStep(container, 1);
    setWholesaleEmailStepFieldsVisible(form, false);
    if (nextBtn) nextBtn.hidden = true;
    var lpEx = container.querySelector('[data-connect-login-prompt]');
    if (lpEx) lpEx.hidden = true;
  }

  function clearAbnTradingNameHint(form) {
    var hints = form.querySelectorAll('[data-abn-trading-name-hint]');
    for (var i = 0; i < hints.length; i++) {
      if (hints[i].parentNode) hints[i].parentNode.removeChild(hints[i]);
    }
  }

  function showAbnTradingNameHint(form, entityName) {
    clearAbnTradingNameHint(form);
    var el = findFieldByName(form, 'tradingName');
    if (!el) return;
    var wrap = el.closest('.custom-form__field');
    if (!wrap) return;
    var hint = document.createElement('p');
    hint.className = 'abn-trading-name-hint';
    hint.setAttribute('data-abn-trading-name-hint', '');
    var countryEl = findFieldByName(form, 'country');
    var _hintCc = countryEl ? normalizeCountryCodeForWholesaleForm(countryEl.value) : 'AU';
    var _registryLabel = _hintCc === 'NZ' ? 'New Zealand Companies Register' : 'Australian Business Register';
    if (el.readOnly) {
      hint.textContent = 'From ' + _registryLabel;
    } else {
      hint.textContent = 'Suggested from ' + _registryLabel + ' – edit if needed';
      function onEdit() {
        clearAbnTradingNameHint(form);
        el.removeEventListener('input', onEdit);
      }
      el.addEventListener('input', onEdit);
    }
    wrap.appendChild(hint);
  }

  function syncTradingNameReadonly(form) {
    var country = findFieldByName(form, 'country');
    var tn = findFieldByName(form, 'tradingName');
    if (!country || !tn) return;
    var _scc = normalizeCountryCodeForWholesaleForm(country.value);
    var isAUorNZ = _scc === 'AU' || _scc === 'NZ';
    tn.readOnly = isAUorNZ;
    tn.classList.toggle('is-readonly', isAUorNZ);
  }

  function initTradingNameReadonlyForAU(form) {
    var country = findFieldByName(form, 'country');
    if (!country) return;
    syncTradingNameReadonly(form);
    country.addEventListener('change', function () { syncTradingNameReadonly(form); });
    country.addEventListener('input', function () { syncTradingNameReadonly(form); });
  }

  function initWholesaleFieldBlurValidate(container, form) {
    var validateUrl = getWholesaleValidateUrl(container);
    if (!validateUrl) return;
    var debounceTimerAbn;
    var debounceTimerAddr;
    function debounceAbn(fn, ms) {
      return function () {
        var ctx = this;
        var args = arguments;
        clearTimeout(debounceTimerAbn);
        debounceTimerAbn = setTimeout(function () {
          fn.apply(ctx, args);
        }, ms);
      };
    }
    function debounceAddr(fn, ms) {
      return function () {
        var ctx = this;
        var args = arguments;
        clearTimeout(debounceTimerAddr);
        debounceTimerAddr = setTimeout(function () {
          fn.apply(ctx, args);
        }, ms);
      };
    }
    function runAbn() {
      clearAbnTradingNameHint(form);
      var abn = findFieldByName(form, 'abn');
      if (!abn || !String(abn.value || '').trim()) return;
      var body = {
        field: 'abn',
        abn: fieldValueByName(form, 'abn'),
        country: fieldValueByName(form, 'country') || 'Australia',
        tradingName: fieldValueByName(form, 'tradingName')
      };
      wholesaleOnboardingAppendDev(body);
      postWholesaleValidate(validateUrl, body).then(function (res) {
        var abnEl = findFieldByName(form, 'abn');
        var trEl = findFieldByName(form, 'tradingName');
        function clearNameAbnUi() {
          setCustomFormFieldError(form, 'abn', '');
          setCustomFormFieldError(form, 'tradingName', '');
          if (abnEl) setWholesaleFieldHighlight(abnEl, false);
          if (trEl) setWholesaleFieldHighlight(trEl, false);
        }
        if (res.httpOk && res.data && res.data.valid === true) {
          clearNameAbnUi();
          var suggestedName = res.data.entityName;
          if (suggestedName) {
            var trSuggest = findFieldByName(form, 'tradingName');
            if (trSuggest) {
              var _fcc = normalizeCountryCodeForWholesaleForm(fieldValueByName(form, 'country'));
              if (_fcc === 'AU' || _fcc === 'NZ' || !trSuggest.value.trim()) {
                trSuggest.value = suggestedName;
                showAbnTradingNameHint(form, suggestedName);
              }
            }
          }
        } else if (res.data && res.data.existingAccount) {
          clearNameAbnUi();
          if (abnEl) setWholesaleFieldHighlight(abnEl, true);
          setAbnExistingAccountError(form);
        } else if (res.data && res.data.message) {
          clearNameAbnUi();
          var msgA = res.data.message;
          var hfa = res.data.highlightFields;
          if (hfa && hfa.length) {
            var ha;
            for (ha = 0; ha < hfa.length; ha++) {
              var elH = findFieldByName(form, hfa[ha]);
              if (elH) setWholesaleFieldHighlight(elH, true);
            }
            for (ha = 0; ha < hfa.length; ha++) {
              setCustomFormFieldError(form, hfa[ha], msgA);
            }
          } else if (abnEl) {
            setWholesaleFieldHighlight(abnEl, true);
            setCustomFormFieldError(form, 'abn', msgA);
          }
        }
      });
    }
    var runAbnD = debounceAbn(runAbn, 500);
    var abnEl = findFieldByName(form, 'abn');
    if (abnEl) {
      abnEl.addEventListener('blur', runAbn);
      abnEl.addEventListener('input', runAbnD);
    }
    var tnAbn = findFieldByName(form, 'tradingName');
    if (tnAbn) {
      tnAbn.addEventListener('blur', runAbnD);
      tnAbn.addEventListener('input', runAbnD);
    }
    function runAddr() {
      var body = {
        field: 'address',
        streetAddress: fieldValueByName(form, 'streetAddress'),
        suburb: fieldValueByName(form, 'suburb'),
        state: fieldValueByName(form, 'state'),
        postcode: fieldValueByName(form, 'postcode'),
        country: fieldValueByName(form, 'country'),
      };
      wholesaleOnboardingAppendDev(body);
      postWholesaleValidate(validateUrl, body).then(function (res) {
        var k;
        for (k = 0; k < WHOLESALE_ADDRESS_FIELD_NAMES.length; k++) {
          var elx = findFieldByName(form, WHOLESALE_ADDRESS_FIELD_NAMES[k]);
          if (elx) setWholesaleFieldHighlight(elx, false);
          setCustomFormFieldError(form, WHOLESALE_ADDRESS_FIELD_NAMES[k], '');
        }
        if (res.httpOk && res.data && res.data.valid === true) return;
        var msg = (res.data && res.data.message) || 'Check address';
        var hf = (res.data && res.data.highlightFields) || WHOLESALE_ADDRESS_FIELD_NAMES;
        for (k = 0; k < hf.length; k++) {
          var el2 = findFieldByName(form, hf[k]);
          if (el2) setWholesaleFieldHighlight(el2, true);
        }
        var first = hf[0] || 'streetAddress';
        setCustomFormFieldError(form, first, msg);
      });
    }
    var runAddrD = debounceAddr(runAddr, 600);
    for (var a = 0; a < WHOLESALE_ADDRESS_FIELD_NAMES.length; a++) {
      var addrEl = findFieldByName(form, WHOLESALE_ADDRESS_FIELD_NAMES[a]);
      if (addrEl) {
        addrEl.addEventListener('blur', runAddr);
        addrEl.addEventListener('input', runAddrD);
      }
    }
  }

  function getAddressSuggestUrl(container) {
    var base = getSubmitHookUrl(container);
    if (!base) return null;
    return base.replace(/wholesale-application(\?|$)/, 'address-suggest$1');
  }

  function initAddressAutocomplete(container, form) {
    if (!isWholesaleApplicationForm(container)) return;
    var suggestUrl = getAddressSuggestUrl(container);
    if (!suggestUrl) { console.warn('[address-suggest] no suggest URL derived from submit hook'); return; }
    var street = findFieldByName(form, 'streetAddress');
    if (!street) { console.warn('[address-suggest] streetAddress field not found in form'); return; }
    console.log('[address-suggest] autocomplete ready, endpoint:', suggestUrl);

    var sessionToken = Math.random().toString(36).slice(2) + Date.now().toString(36);
    var debounceTimer = null;
    var currentSuggestions = [];
    var activeIdx = -1;

    var wrapper = street.closest('.custom-form__field') || street.parentNode;
    wrapper.style.position = 'relative';

    var dropdown = document.createElement('div');
    dropdown.className = 'custom-form__address-dropdown';
    dropdown.setAttribute('role', 'listbox');
    dropdown.setAttribute('aria-label', 'Address suggestions');
    dropdown.hidden = true;
    wrapper.appendChild(dropdown);

    var changeBtn = document.createElement('button');
    changeBtn.type = 'button';
    changeBtn.className = 'custom-form__address-change-btn';
    changeBtn.textContent = 'Change address';
    changeBtn.hidden = true;
    wrapper.appendChild(changeBtn);

    function lockAddressFields() {
      for (var li = 0; li < WHOLESALE_ADDRESS_FIELD_NAMES.length; li++) {
        var lel = findFieldByName(form, WHOLESALE_ADDRESS_FIELD_NAMES[li]);
        if (lel) { lel.readOnly = true; lel.classList.add('is-readonly'); }
      }
      changeBtn.hidden = false;
    }

    function unlockAddressFields() {
      var countryEl = findFieldByName(form, 'country');
      var preservedCountry = countryEl ? countryEl.value : '';
      var keepCountry = (preservedCountry === 'New Zealand') ? 'New Zealand' : 'Australia';
      for (var ui = 0; ui < WHOLESALE_ADDRESS_FIELD_NAMES.length; ui++) {
        var uel = findFieldByName(form, WHOLESALE_ADDRESS_FIELD_NAMES[ui]);
        if (!uel) continue;
        uel.readOnly = false;
        uel.classList.remove('is-readonly');
        if (uel.name === 'country') {
          uel.value = keepCountry;
        } else {
          uel.value = '';
        }
      }
      changeBtn.hidden = true;
      if (street) { street.focus(); }
    }

    changeBtn.addEventListener('click', unlockAddressFields);

    function esc(s) {
      return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function closeDropdown() {
      dropdown.hidden = true;
      dropdown.innerHTML = '';
      currentSuggestions = [];
      activeIdx = -1;
    }

    function setActiveItem(idx) {
      var items = dropdown.querySelectorAll('.custom-form__address-option');
      for (var i = 0; i < items.length; i++) {
        items[i].classList.toggle('custom-form__address-option--active', i === idx);
        items[i].setAttribute('aria-selected', i === idx ? 'true' : 'false');
      }
      activeIdx = idx;
    }

    function fillFields(components) {
      if (!components) return;
      var sa = findFieldByName(form, 'streetAddress');
      var su = findFieldByName(form, 'suburb');
      var st = findFieldByName(form, 'state');
      var pc = findFieldByName(form, 'postcode');
      var ct = findFieldByName(form, 'country');
      if (sa && components.streetAddress) sa.value = components.streetAddress;
      if (su && components.suburb) su.value = components.suburb;
      if (st && components.state) st.value = components.state;
      if (pc && components.postcode) pc.value = components.postcode;
      if (ct && components.country) ct.value = components.country;
      if (ct) {
        ct.dispatchEvent(new Event('input', { bubbles: true }));
        ct.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function selectSuggestion(idx) {
      var s = currentSuggestions[idx];
      if (!s) return;
      if (street) street.value = s.mainText;
      closeDropdown();

      var sep = suggestUrl.indexOf('?') !== -1 ? '&' : '?';
      var detailUrl = suggestUrl + sep + 'placeId=' + encodeURIComponent(s.placeId) + '&sessiontoken=' + encodeURIComponent(sessionToken);
      sessionToken = Math.random().toString(36).slice(2) + Date.now().toString(36);

      fetch(detailUrl)
        .then(function(r) { return r.json(); })
        .then(function(data) { fillFields(data.components); lockAddressFields(); })
        .catch(function() {});
    }

    function renderDropdown(suggestions) {
      currentSuggestions = suggestions || [];
      activeIdx = -1;
      if (!currentSuggestions.length) { closeDropdown(); return; }
      var html = '';
      for (var i = 0; i < currentSuggestions.length; i++) {
        var sg = currentSuggestions[i];
        html += '<div class="custom-form__address-option" role="option" aria-selected="false" data-idx="' + i + '">' +
          '<span class="custom-form__address-option-main">' + esc(sg.mainText) + '</span>' +
          (sg.secondaryText ? '<span class="custom-form__address-option-sub">' + esc(sg.secondaryText) + '</span>' : '') +
          '</div>';
      }
      dropdown.innerHTML = html;
      dropdown.hidden = false;
      var items = dropdown.querySelectorAll('.custom-form__address-option');
      for (var j = 0; j < items.length; j++) {
        (function(item, idx) {
          item.addEventListener('mousedown', function(e) {
            e.preventDefault();
            selectSuggestion(idx);
          });
        })(items[j], j);
      }
    }

    street.addEventListener('input', function() {
      var val = (street.value || '').trim();
      if (debounceTimer) clearTimeout(debounceTimer);
      if (val.length < 3) { closeDropdown(); return; }
      debounceTimer = setTimeout(function() {
        var sep = suggestUrl.indexOf('?') !== -1 ? '&' : '?';
        var reqUrl = suggestUrl + sep + 'input=' + encodeURIComponent(val) + '&sessiontoken=' + encodeURIComponent(sessionToken);
        fetch(reqUrl)
          .then(function(r) {
            if (!r.ok) { console.warn('[address-suggest] HTTP ' + r.status + ' from ' + reqUrl); return { suggestions: [] }; }
            return r.json();
          })
          .then(function(data) {
            if (!data.suggestions || !data.suggestions.length) {
              console.warn('[address-suggest] no suggestions for "' + val + '" — Google status:', data._status || 'ZERO_RESULTS', data);
            }
            renderDropdown(data.suggestions);
          })
          .catch(function(err) { console.error('[address-suggest] fetch error', err); closeDropdown(); });
      }, 300);
    });

    street.addEventListener('keydown', function(e) {
      var items = dropdown.querySelectorAll('.custom-form__address-option');
      if (!items.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActiveItem(Math.min(activeIdx + 1, items.length - 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActiveItem(Math.max(activeIdx - 1, 0));
      } else if (e.key === 'Enter' && activeIdx >= 0) {
        e.preventDefault();
        selectSuggestion(activeIdx);
      } else if (e.key === 'Escape') {
        closeDropdown();
      }
    });

    street.addEventListener('blur', function() {
      setTimeout(closeDropdown, 200);
    });
  }

  function initSteps(container, form) {
    const stepsWrap = container.querySelector('.custom-form__steps');
    const stepNav = container.querySelector('[data-step-nav]');
    const submitWrap = container.querySelector('[data-submit-wrap]');
    if (!stepsWrap || stepsWrap.getAttribute('data-multi-step') !== 'true' || !stepNav || !submitWrap) return;
    const steps = container.querySelectorAll('.custom-form__step');
    if (steps.length === 0) return;
    submitWrap.hidden = true;
    stepNav.hidden = false;
    goToStep(container, 1);

    const nextLabel = container.getAttribute('data-next-label') || 'Next';
    const checkingLabel = 'Checking…';
    const backLabel = container.getAttribute('data-back-label') || 'Back';
    var nextBtn = container.querySelector('[data-custom-form-next]');
    var backBtn = container.querySelector('[data-custom-form-back]');
    if (nextBtn) nextBtn.textContent = nextLabel;
    if (backBtn) backBtn.textContent = backLabel;

    nextBtn = container.querySelector('[data-custom-form-next]');
    backBtn = container.querySelector('[data-custom-form-back]');
    const wholesaleAsync = isWholesaleApplicationForm(container) && getWholesaleValidateUrl(container);
    const validateUrl = wholesaleAsync ? getWholesaleValidateUrl(container) : null;
    var onboardingUrl = wholesaleAsync ? getWholesaleOnboardingUrl(container) : null;
    var onboardingFlow = !!(onboardingUrl && isWholesaleOnboardingFlowEnabled(container));

    if (nextBtn) {
      if (wholesaleAsync && validateUrl) {
        nextBtn.addEventListener('click', function onWholesaleNext() {
          const steps2 = container.querySelectorAll('.custom-form__step');
          var businessStep = getWholesaleBusinessStepIndex(container);
          var current = getEffectiveCurrentStepIndex(container);
          if (current <= 0 || current >= steps2.length) return;
          clearFieldErrors(form);
          clearWholesaleFieldHighlights(form);
          const stepEl = steps2[current - 1];
          const errs = validateForm(form, stepEl);
          if (errs.length > 0) {
            showMessage(container, container.getAttribute('data-error-message') || 'Please check the highlighted fields.', true);
            return;
          }

          if (onboardingFlow && onboardingUrl && current === 1 && !stepEl.querySelector('[name="abn"]')) {
            var em = fieldValueByName(form, 'primaryEmail');
            nextBtn.disabled = true;
            var prevT0 = nextBtn.textContent;
            nextBtn.textContent = checkingLabel;
            postWholesaleOnboarding(
              onboardingUrl,
              wholesaleOnboardingAppendDev({ action: 'emailCheck', email: em })
            )
              .then(function (r) {
                nextBtn.disabled = false;
                nextBtn.textContent = prevT0 || nextLabel;
                if (!r.httpOk || !r.data || r.data.success !== true) {
                  showMessage(container, (r.data && r.data.error) || 'Could not verify email.', true);
                  return;
                }
                var kind = r.data.customerKind;
                if (kind === 'invalid') {
                  showMessage(container, 'Please enter a valid email address.', true);
                  return;
                }
                container.setAttribute('data-wholesale-gate-email', em);
                if (kind === 'b2b_contact' || kind === 'customer_only') {
                  hideMessage(container);
                  renderWholesaleExistingAccountPanel(container, form, nextBtn);
                  return;
                }
                if (kind === 'not_found') {
                  hideMessage(container);
                  renderWholesaleEmailNotMatchedPanel(container, form, onboardingUrl, nextBtn, businessStep, r.data.pendingRequestLocationName || null);
                  return;
                }
                showMessage(container, 'Unexpected response. Please try again.', true);
              })
              .catch(function () {
                nextBtn.disabled = false;
                nextBtn.textContent = prevT0 || nextLabel;
                showMessage(container, 'Could not verify email. Try again.', true);
              });
            return;
          }

          if (current !== businessStep) {
            hideMessage(container);
            goToStep(container, current + 1);
            return;
          }

          var payload = {
            field: 'step1',
            abn: fieldValueByName(form, 'abn'),
            tradingName: fieldValueByName(form, 'tradingName'),
            country: fieldValueByName(form, 'country'),
            streetAddress: fieldValueByName(form, 'streetAddress'),
            suburb: fieldValueByName(form, 'suburb'),
            state: fieldValueByName(form, 'state'),
            postcode: fieldValueByName(form, 'postcode'),
          };
          wholesaleOnboardingAppendDev(payload);

          nextBtn.disabled = true;
          const prevText = nextBtn.textContent;
          nextBtn.textContent = checkingLabel;

          runWholesaleStep1Validation(validateUrl, payload)
            .then(function (result) {
              nextBtn.disabled = false;
              nextBtn.textContent = prevText || nextLabel;
              if (!result.httpOk) {
                var failMsg = (result.data && (result.data.error || result.data.message)) || 'Could not validate. Please try again.';
                showMessage(container, String(failMsg), true);
                return;
              }
              if (result.data && result.data.valid === true) {
                clearWholesaleStep1InlineErrors(form);
                hideMessage(container);
                goToStep(container, current + 1);
                return;
              }
              applyWholesaleStep1ResultUI(form, container, result.data || {});
            })
            .catch(function () {
              nextBtn.disabled = false;
              nextBtn.textContent = prevText || nextLabel;
              showMessage(container, 'Could not validate. Please try again.', true);
            });
        });
      } else {
        nextBtn.addEventListener('click', function onNext() {
          const steps2 = container.querySelectorAll('.custom-form__step');
          var current = getEffectiveCurrentStepIndex(container);
          if (current <= 0 || current >= steps2.length) return;
          clearFieldErrors(form);
          const stepEl = steps2[current - 1];
          const errs = validateForm(form, stepEl);
          if (errs.length > 0) {
            showMessage(container, container.getAttribute('data-error-message') || 'Please check the highlighted fields.', true);
            return;
          }
          hideMessage(container);
          goToStep(container, current + 1);
        });
      }
    }
    if (backBtn) {
      backBtn.addEventListener('click', function onBack() {
        const steps2 = container.querySelectorAll('.custom-form__step');
        var current = getEffectiveCurrentStepIndex(container);
        if (current <= 1) return;
        var target = current - 1;
        if (target === 1 && isWholesaleOnboardingFlowEnabled(container)) {
          clearWholesaleOnboardingHost(container);
          var nb = container.querySelector('[data-custom-form-next]');
          if (nb) nb.hidden = false;
        }
        clearFieldErrors(form);
        clearWholesaleFieldHighlights(form);
        hideMessage(container);
        goToStep(container, target);
      });
    }
  }

  function handleSubmit(ev) {
    const form = ev.target;
    const container = form.closest(FORM_SELECTOR);
    if (!container) return;
    const submitHook = getSubmitHookUrl(container);
    if (!submitHook) return;

    // For multi-step forms, Enter key should advance via the Next button, not submit the form.
    const stepsWrap = container.querySelector('.custom-form__steps');
    if (stepsWrap && stepsWrap.getAttribute('data-multi-step') === 'true') {
      const nextBtn = container.querySelector('[data-custom-form-next]');
      if (nextBtn && !nextBtn.hidden && !nextBtn.disabled) {
        ev.preventDefault();
        nextBtn.click();
        return;
      }
    }

    ev.preventDefault();
    clearFieldErrors(form);
    hideMessage(container);

    const validationErrors = validateForm(form);
    if (validationErrors.length > 0) {
      showMessage(container, container.getAttribute('data-error-message') || 'Please check the highlighted fields.', true);
      return;
    }

    const payload = buildPayload(form, container);
    if (isDebug() && typeof console !== 'undefined' && console.log) {
      console.log('[Custom form] Payload:', payload);
    }
    const devParam = typeof URLSearchParams !== 'undefined' && new URLSearchParams(window.location.search).get('dev') === '1';
    if (devParam) payload.backend = 'dev';

    setSubmitting(container, true);

    fetch(submitHook, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        const contentType = (res.headers.get('Content-Type') || '').toLowerCase();
        return res.text().then(function (text) {
          var data = {};
          if (contentType.indexOf('application/json') !== -1) {
            try {
              data = text ? JSON.parse(text) : {};
            } catch (e) {
              data = { error: 'Invalid response' };
            }
          } else if (res.ok === false && text) {
            data = { error: 'Server error. Please try again later.' };
          }
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function (result) {
        setSubmitting(container, false);
        if (result.ok && result.data && result.data.success !== false) {
          var submittedEmail = fieldValueByName(form, 'primaryEmail');
          var usedConnectSuccess =
            container.getAttribute('data-connect-register-layout') === '1' &&
            showConnectRegisterSuccess(container, form, submittedEmail);
          if (!usedConnectSuccess) {
            showMessage(container, container.getAttribute('data-success-message') || 'Thank you.', false);
          }
          form.reset();
          if (container.getAttribute('data-recaptcha-site-key') && typeof window.grecaptcha !== 'undefined' && window.grecaptcha.reset) {
            try { window.grecaptcha.reset(); } catch (e) {}
          }

        } else if (result.data && Array.isArray(result.data.errors)) {
          applyBackendErrors(form, container, result.data.errors);
        } else {
          const msg = (result.data && result.data.message) || (result.data && result.data.error) || container.getAttribute('data-error-message') || 'Something went wrong.';
          showMessage(container, msg, true);
        }
      })
      .catch(function (err) {
        setSubmitting(container, false);
        showMessage(container, container.getAttribute('data-error-message') || 'Something went wrong. Please try again.', true);
        if (isDebug() && typeof console !== 'undefined' && console.error) {
          console.error('[Custom form] Request failed:', err);
        }
      });
  }

  /**
   * Assigns tabindex values so keyboard tab order goes down the left column first,
   * then the right column — matching the visual column layout after blocks are
   * reordered in the Shopify editor. Full-width fields before the first right-column
   * field keep their DOM position at the start; those after keep it at the end.
   * Safe to call on hidden steps (returns early when container has no width).
   */
  function applyColumnFirstTabOrder(stepEl) {
    if (!stepEl) return;
    var stepRect = stepEl.getBoundingClientRect();
    if (stepRect.width === 0) return;

    var midX = stepRect.left + stepRect.width / 2;
    var allFocusable = stepEl.querySelectorAll(
      'input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled])'
    );
    if (allFocusable.length === 0) return;

    var items = [];
    var rightColExists = false;
    for (var i = 0; i < allFocusable.length; i++) {
      var el = allFocusable[i];
      var wrapper = el.closest('.custom-form__field') || el;
      var rect = wrapper.getBoundingClientRect();
      if (rect.width === 0) continue;
      var isHalf = rect.width < stepRect.width * 0.65;
      var isRight = isHalf && (rect.left + rect.width / 2) >= midX;
      if (isRight) rightColExists = true;
      items.push({ el: el, isHalf: isHalf, isRight: isRight, domIdx: i });
    }

    if (!rightColExists) return;

    var firstRightDomIdx = items.reduce(function(min, item) {
      return item.isRight && item.domIdx < min ? item.domIdx : min;
    }, Infinity);

    var preFullWidth = [], leftCol = [], rightCol = [], postFullWidth = [];
    for (var j = 0; j < items.length; j++) {
      var it = items[j];
      if (it.isRight) {
        rightCol.push(it.el);
      } else if (!it.isHalf) {
        if (it.domIdx < firstRightDomIdx) preFullWidth.push(it.el);
        else postFullWidth.push(it.el);
      } else {
        leftCol.push(it.el);
      }
    }

    for (var k = 0; k < allFocusable.length; k++) allFocusable[k].removeAttribute('tabindex');

    var seq = preFullWidth.concat(leftCol).concat(rightCol).concat(postFullWidth);
    for (var m = 0; m < seq.length; m++) seq[m].setAttribute('tabindex', String(m + 1));
  }

  function initTelFields(form) {
    var fields = form.querySelectorAll('[data-tel-field]');
    for (var i = 0; i < fields.length; i++) {
      (function(field) {
        var countrySelect = field.querySelector('[data-tel-country-code]');
        var numberInput = field.querySelector('[data-tel-number]');
        var hiddenInput = field.querySelector('[data-tel-combined]');
        if (!hiddenInput) return;

        function sync() {
          var code = countrySelect ? countrySelect.value : '';
          var num = numberInput ? numberInput.value.trim() : '';
          hiddenInput.value = num ? (code + ' ' + num) : '';
        }

        if (countrySelect) countrySelect.addEventListener('change', sync);
        if (numberInput) numberInput.addEventListener('input', sync);
        sync();
      })(fields[i]);
    }
  }

  function initDeliveryDaysBlocks(form) {
    var blocks = form.querySelectorAll('[data-delivery-days-block]');
    for (var i = 0; i < blocks.length; i++) {
      (function(block) {
        var prefInput = block.querySelector('[data-delivery-days-preferred]');
        var winInput = block.querySelector('[data-delivery-time-windows]');
        var dayCheckboxes = block.querySelectorAll('[data-delivery-day]');
        var fromInput = block.querySelector('[data-delivery-time-from]');
        var toInput = block.querySelector('[data-delivery-time-to]');
        if (!prefInput || !winInput) return;

        function formatTime(timeVal) {
          if (!timeVal) return '';
          var parts = timeVal.split(':');
          var h = parseInt(parts[0], 10);
          var m = parseInt(parts[1] || '0', 10);
          var ampm = h >= 12 ? 'pm' : 'am';
          var h12 = h % 12 || 12;
          return h12 + (m ? ':' + (m < 10 ? '0' + m : String(m)) : '') + ampm;
        }

        function sync() {
          var days = [];
          for (var d = 0; d < dayCheckboxes.length; d++) {
            if (dayCheckboxes[d].checked) days.push(dayCheckboxes[d].value);
          }
          prefInput.value = days.join(', ');
          var from = fromInput ? formatTime(fromInput.value) : '';
          var to = toInput ? formatTime(toInput.value) : '';
          winInput.value = from && to ? from + ' – ' + to : from || to;
        }

        for (var d = 0; d < dayCheckboxes.length; d++) {
          dayCheckboxes[d].addEventListener('change', sync);
        }
        if (fromInput) fromInput.addEventListener('change', sync);
        if (toInput) toInput.addEventListener('change', sync);
        sync();
      })(blocks[i]);
    }
  }

  function init() {
    const containers = document.querySelectorAll(FORM_SELECTOR);
    for (let i = 0; i < containers.length; i++) {
      const container = containers[i];
      const submitHook = getSubmitHook(container);
      const form = container.querySelector('form');
      if (!form || !submitHook) continue;
      form.removeEventListener('submit', handleSubmit);
      form.addEventListener('submit', handleSubmit);
      initSteps(container, form);
      initConnectRegisterLoginLinks(container);
      initAbnNzbnLabel(form);
      initTelFields(form);
      initDeliveryDaysBlocks(form);
      var firstVisibleStep = form.querySelector('.custom-form__step:not([hidden])');
      if (firstVisibleStep) applyColumnFirstTabOrder(firstVisibleStep);
      if (isWholesaleApplicationForm(container)) {
        var defCountry = findFieldByName(form, 'country');
        if (defCountry && !defCountry.value.trim()) {
          defCountry.value = 'Australia';
          defCountry.dispatchEvent(new Event('input', { bubbles: true }));
          defCountry.dispatchEvent(new Event('change', { bubbles: true }));
        }
        initWholesaleFieldBlurValidate(container, form);
        initAddressAutocomplete(container, form);
        initTradingNameReadonlyForAU(form);
      }

    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
